import { MenuItem, Select, Stack, Typography } from "@mui/material";
import { convertToNumber } from "@entrilia/shared/utilities/numberHelper";

interface Props {
  value: number;
  onChange: (value: number) => void;
}

const options = [10, 20, 50, 100, 200] as const;

const RowsPerPageSelector = ({ value, onChange }: Props) => {
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "baseline" }}>
      <Typography variant="caption" color="textSecondary">
        Rows per page:
      </Typography>
      <Select<number>
        value={value}
        onChange={(e) => onChange(convertToNumber(e.target.value) ?? options[0])}
        disableUnderline
        variant="standard"
        renderValue={(val) => <Typography variant="body2">{val}</Typography>}
      >
        {options.map((val) => (
          <MenuItem key={val.toString()} value={val}>
            {val.toString()}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

export default RowsPerPageSelector;
